import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PendingReport } from '../../types/dashboard.types';
import './ReportsCard.styles.css';

interface ReportsCardProps {
  pendingReports: PendingReport[];
}

export const ReportsCard: React.FC<ReportsCardProps> = ({ pendingReports }) => {
  const navigate = useNavigate();

  const handleReportClick = (reportId: string) => {
    navigate('/expert/a-traiter');
  };

  return (
    <div className="dashboard-card reports-card">
      <div className="dashboard-card-header">
        <h3 className="dashboard-card-title">Rapports à finaliser</h3>
        <span className="info-badge">{pendingReports.length}</span>
      </div>
      <div className="reports-list">
        {pendingReports.length > 0 ? (
          pendingReports.map(report => (
            <div 
              key={report.id} 
              className="report-item clickable"
              onClick={() => handleReportClick(report.id)}
            >
              <div className="report-ref">{report.ref}</div>
              <div className="report-property">{report.property}</div>
              <div className="report-info">
                Visite il y a {report.daysAgo} jour{report.daysAgo > 1 ? 's' : ''}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">Aucun rapport en attente</div>
        )}
      </div>
    </div>
  );
};